// extracted by mini-css-extract-plugin
export default {"monitor":"Monitor_monitor__eP86Z","monitorStatus":"Monitor_monitorStatus__UwDo0","monitorStatusText":"Monitor_monitorStatusText__4VLGG","monitorBg":"Monitor_monitorBg__0BnKH"};